import axios from 'axios';
import { Shopify } from './constants';

export const addShopifyStore = (shopifyCookie) => {
  const payload = {
    ...shopifyCookie,
    referralCode: Shopify,
  };
  return axios.post('/store/add-store', payload);
};
